module.exports = __webpack_public_path__ + "img/emprendimiento.c98604b1.jpg";